import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Handles the OAuth callback: reads `session_id` from URL fragment,
 * exchanges it for a session cookie, then routes to /admin/leads.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await exchangeSession(session_id);
        setUser(user);
        // Clean URL and go to the dashboard
        window.history.replaceState({}, "", "/admin/leads");
        navigate("/admin/leads", { replace: true, state: { user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed.");
        setTimeout(() => navigate("/admin/login", { replace: true }), 1800);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="admin-shell">
      <div className="admin-loading" data-testid="admin-callback-status">
        {error ? error : "Signing you in…"}
      </div>
    </div>
  );
}
